<template>
  <nav class="flex flex-col justify-start items-center bg-lightgray">
    <router-link
      class="uppercase py-8 px-10 w-full select-none hover:font-bold"
      :class="{
        'router-link-active': item.name === 'Projects' && projectsLinkActive
      }"
      v-for="item in sidebarItems"
      :key="item.name"
      :to="item.to"
      :exact="item.exact"
      >{{ item.name }}
    </router-link>
  </nav>
</template>

<script>
import { UserTypes } from "../../constants/user-enums";

export default {
  name: "Sidebar",
  computed: {
    userType() {
      return this.$store.state.userType;
    },
    sidebarItems() {
      if (this.userType === UserTypes.CREW_LEADER) {
        return [{ name: "Dashboard", to: "/", exact: true }];
      }
      if (
        this.userType === UserTypes.DESIGNER ||
        this.userType === UserTypes.CREW_SUPERVISOR
      ) {
        return [
          { name: "Dashboard", to: "/", exact: true },
          { name: "Projects", to: "/projects" }
        ];
      }
      return [
        { name: "Dashboard", to: "/", exact: true },
        { name: "Projects", to: "/projects" },
        { name: "Contacts", to: "/contacts" },
        { name: "Crews", to: "/crews" },
        { name: "Items", to: "/items" },
        { name: "Users", to: { name: "users" } }
      ];
    },
    projectsLinkActive() {
      return (
        this.$route.name === "contracts-show" ||
        this.$route.name.indexOf("contract-") > -1
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.router-link-active {
  @apply text-red font-bold;
}
</style>
